module.exports = __webpack_public_path__ + "static/media/btn3.d97c58a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/btn3.png
// module id = 1219
// module chunks = 0